// extracted by mini-css-extract-plugin
export default {"title":"BodyfillersContent_title__ldFhY","container":"BodyfillersContent_container__5NTya","product":"BodyfillersContent_product__CdIWi","export":"BodyfillersContent_export__Jp+30"};